
export { useValidateAddressMutation } from "/home/jenkins/agent/workspace/web-sunrise-prod/web-sunrise-consumer-deploy-prod/libs/consumer/data-access/src/lib/api/coverage-tool/validateAddress.ts"